export function isPathOnlyUrl(url: string) {
  return Boolean(url.match(/^\/[^/]/));
}
